import { render } from "./after_sale.vue?vue&type=template&id=d50f146c&scoped=true"
import script from "./after_sale.vue?vue&type=script&lang=js"
export * from "./after_sale.vue?vue&type=script&lang=js"

import "./after_sale.vue?vue&type=style&index=0&id=d50f146c&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50f146c"]])

export default __exports__